var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24811_50686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8307 28.3332L18.3307 25.8332M18.3307 25.8332L20.8307 23.3332M18.3307 25.8332H22.4974C25.7191 25.8332 28.3307 23.2215 28.3307 19.9998C28.3307 17.6728 26.9682 15.6641 24.9974 14.7279M14.9974 25.2718C13.0266 24.3356 11.6641 22.3268 11.6641 19.9998C11.6641 16.7782 14.2757 14.1665 17.4974 14.1665H21.6641M21.6641 14.1665L19.1641 11.6665M21.6641 14.1665L19.1641 16.6665",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24811_50686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatIcon);
export default __webpack_public_path__ + "static/media/repeat-icon.8a565dad3694ba8ac11610c225232d73.svg";
export { ForwardRef as ReactComponent };